import { Fragment, useContext } from "react"
import { ActionButton, Button, Loading, Modal } from "../../../../../../../../../components"
import { FormSection } from "../../../../FormSection"
import { FormProvider, useForm } from "react-hook-form"
import toast from "react-hot-toast"
import type { ListDepartement } from "../../../../../types"
import { useApi, useToggle } from "../../../../../../../../../utils"
import { Render } from "../../../../../utils"
import { useDetail } from "../utils"

export function Delete(props: { id: ListDepartement, refetch?: () => void  }) {
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      <ActionButton.Delete className="join-item" onClick={toggle} />
      {isActive && <ModalSection id={props.id} toggle={toggle} refetch={props.refetch}/>}
    </Fragment>
  )
}

function ModalSection(props: {
  id: ListDepartement
  toggle: () => void
  refetch?: () => void
}) {
  const { data, dataError, isLoading } = useDetail()

  return (
    <Modal isOpen title="DELETE DEPARTEMENT" size="xl" closeModal={props.toggle}>
      {isLoading || dataError ? (
        <Loading errorText={dataError} loading={isLoading} />
      ) : (
        <DataForm data={data!} id={props.id} toggle={props.toggle}  refetch={props.refetch} />
      )}
    </Modal>
  )
}

function DataForm(props: {
  data: ListDepartement
  id: ListDepartement
  toggle: () => void
  refetch?: () => void
}) {
  const api = useApi()
  const { toggle } = useContext(Render)

  const onSubmit = ( value: ListDepartement ) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.delete("/department/delete", { params: { department_id: props.id.department_id } }),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => {
            if (err.response && err.response.status === 400) {
              return err.response.data.detail.message || "Bad Request";
            } else {
              return "The data cannot be deleted as it is still associated with other data";
            }
          }
        }
      ).then(() => {
        props.toggle()
        props?.refetch && props.refetch()
        toggle()
      }).catch(() => {}).finally(resolve)
    })
  }
  const methods = useForm({ defaultValues: props.id })

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <h5 className="text-error">Are you sure want to delete this data?</h5>
        <FormSection isDetail action="DELETE" />

        <Modal.Footer className="text-end">
          <Button type="submit" color="error" loading={methods.formState.isSubmitting ? "true" : undefined}>Delete</Button>
        </Modal.Footer>
      </form>
    </FormProvider>
  )
}